export * from './auth.guard';



// WEBPACK FOOTER //
// ./src/app/pages/authentication/_guards/index.ts